export default "__VITE_ASSET__ArJVR9uB__"